import React from 'react';

import { Translate } from 'react-localize-redux';
import { type RouteComponentProps, Route, Switch } from 'react-router';

import LazyComponent from '@fd/ui/LazyComponent';
import Permissions from '@fd/ui/Permissions';

import { toKebabCase } from '../../../helpers/strings';
import { lazyWithRetry } from '../../../helpers/utilities';
import ErrorBoundary from '../../../layouts/Portal/ErrorBoundary';
import { RMSModules } from '../utils/rmsModules';
import { RMSSubscriptions } from '../utils/rmsSubscriptions';

const RMSPage = lazyWithRetry(() => import('../components/RMSPage'));
const Staff = lazyWithRetry(() => import('./Staff'));

const StaffRoutes: React.FC<React.PropsWithChildren<RouteComponentProps>> = (
  props: RouteComponentProps
) => {
  const {
    match: { path },
  } = props;
  const baseUrl = `modules/payroll`;
  return (
    <ErrorBoundary identifier="staff">
      <Switch>
        <Route
          exact
          path={`${path}`}
          render={() => (
            <LazyComponent>
              <Staff />
            </LazyComponent>
          )}
        />
        <Route
          exact
          path={`${path}/${toKebabCase(RMSModules.STAFF)}`}
          render={() => (
            <Permissions allowed={['ViewPayrollStaff', 'EditPayrollStaff']}>
              <LazyComponent>
                <RMSPage
                  subscription={RMSSubscriptions.BASE}
                  title={<Translate id="Staff" />}
                  module={RMSModules.STAFF}
                  url={`${baseUrl}/${RMSModules.STAFF}`}
                  includePropertyIdInUrl
                  editPermissions={['EditPayrollStaff']}
                />
              </LazyComponent>
            </Permissions>
          )}
        />
        <Route
          exact
          path={`${path}/${toKebabCase(RMSModules.STAFF_ROLES)}`}
          render={() => (
            <Permissions allowed={['ViewPayrollStaff', 'EditPayrollStaff']}>
              <LazyComponent>
                <RMSPage
                  subscription={RMSSubscriptions.BASE}
                  title={<Translate id="Staff_Roles" />}
                  module={RMSModules.STAFF_ROLES}
                  url={`${baseUrl}/${RMSModules.STAFF_ROLES}`}
                  includePropertyIdInUrl
                  editPermissions={['EditPayrollStaff']}
                />
              </LazyComponent>
            </Permissions>
          )}
        />
        <Route
          exact
          path={`${path}/${toKebabCase(RMSModules.STAFF_PERMISSIONS_CONFIGURATION)}`}
          render={() => (
            <Permissions allowed={['EditPayrollStaff']}>
              <LazyComponent>
                <RMSPage
                  subscription={RMSSubscriptions.BASE}
                  title={<Translate id="Staff_Permissions" />}
                  module={RMSModules.STAFF_PERMISSIONS_CONFIGURATION}
                  url={`configurations/franchisors/properties/${RMSModules.STAFF_PERMISSIONS_CONFIGURATION}`}
                  includePropertyIdInUrl
                  editPermissions={['EditPayrollStaff']}
                />
              </LazyComponent>
            </Permissions>
          )}
        />
      </Switch>
    </ErrorBoundary>
  );
};

export default StaffRoutes;
